'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'

interface NavItem {
  href: string
  label: string
}

const EXPERT_LINKS: NavItem[] = [
  { href: '/inbox', label: 'Inbox' },
  { href: '/knowledge', label: 'Knowledge' },
  { href: '/admin/projects', label: 'Projects' },
  { href: '/admin/users', label: 'Users' },
]

const ADMIN_EXTRA_LINKS: NavItem[] = [
  { href: '/admin/config', label: 'Config' },
]

const MANAGER_LINKS: NavItem[] = [
  { href: '/submit', label: 'Submit' },
  { href: '/tickets', label: 'My Tickets' },
]

interface Props {
  isExpert: boolean
  isAdmin?: boolean
}

export default function NavLinks({ isExpert, isAdmin }: Props) {
  const pathname = usePathname()
  const links = isExpert
    ? [...EXPERT_LINKS, ...(isAdmin ? ADMIN_EXTRA_LINKS : [])]
    : MANAGER_LINKS

  function isActive(href: string) {
    if (href === '/inbox') return pathname === '/inbox' || pathname.startsWith('/inbox/')
    return pathname === href || pathname.startsWith(href + '/')
  }

  return (
    <nav aria-label="Primary" className="flex items-center gap-1">
      {links.map(({ href, label }) => (
        <Link
          key={href}
          href={href}
          className={`rounded-md px-3 py-1.5 text-xs font-medium transition ${
            isActive(href)
              ? 'bg-zinc-100 text-zinc-950 dark:bg-zinc-800 dark:text-white'
              : 'text-zinc-500 hover:bg-zinc-100 hover:text-zinc-950 dark:text-zinc-400 dark:hover:bg-zinc-800 dark:hover:text-white'
          }`}
        >
          {label}
        </Link>
      ))}
    </nav>
  )
}
